import { BaseService } from "../../core/baseService";
import {
  SentimentServiceInterface,
  SentimentSummaryDto,
} from "../types/sentiment.types";
import { ApiResult } from "../../core/types";

export class SentimentService extends BaseService implements SentimentServiceInterface {
  async getSentimentSummary(qrTokenId: string): Promise<ApiResult<SentimentSummaryDto>> {
    return this.handleRequest<SentimentSummaryDto>(
      this.client.get(`/api/admin/sentiment/${qrTokenId}`),
    );
  }

  async reanalyzeSentiment(qrTokenId: string): Promise<ApiResult<SentimentSummaryDto>> {
    return this.handleRequest<SentimentSummaryDto>(
      this.client.get(`/api/admin/sentiment/${qrTokenId}/analyze`),
    );
  }
}
